import React, { useRef } from 'react';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import GrantDisclaimerModal from './GrantDisclaimerModal';

class AccessType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            showGrantDisclaimerModal: false,
            agreedGrantDisclaimer: false
        };
        this.isValid = this.isValid.bind(this);
        this.onAgreeGrantDisclaimer = this.onAgreeGrantDisclaimer.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AccessType.ComponentDidMount", new Date(), Tools.getURLPath());        
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.agreedGrantDisclaimer && !prevState.showGrantDisclaimerModal) {//reset state
            this.setState({
                showGrantDisclaimerModal: false,
                agreedGrantDisclaimer: false
            });
        }        
    }

    isValid() {
        const { healthrecord, pharmacy } = this.props;
        const { agreedGrantDisclaimer } = this.state;
        if (!agreedGrantDisclaimer && (healthrecord || pharmacy)) {
            this.setState({ showGrantDisclaimerModal: true });
        }

        if (agreedGrantDisclaimer && (healthrecord || pharmacy)) return true;
        this.setState({
            error: !healthrecord && !pharmacy ? 'Please select an access type' : ''
        }, () => {
            if (this.props.onContinueClick) {
                this.props.onContinueClick(this.state.error);
            }
        });
    }   

    onAgreeGrantDisclaimer(agreed) {
        const { healthrecord, pharmacy } = this.props;       
        if (agreed) {
            this.setState({ agreedGrantDisclaimer: true, showGrantDisclaimerModal: false }, () => {
                if (this.props.goNext) {
                    this.props.goNext(true);
                }
            });
        }
        else {
            logUI(`MBHWeb.UI.GrantDisclaimerModal.OnClose`, new Date(), Tools.getURLPath(), { "healthrecord": healthrecord, "pharmacy": pharmacy, "agreed": false, "fromProxyDashboard": false });
        }
        this.setState({ showGrantDisclaimerModal: false });
    }

    onAccessTypeChange = (e) => {
        if (e.target) {
            this.setState({ agreedGrantDisclaimer: false });
            this.props.onAccessTypeChange(e); 
            if (e.target.checked) {
                this.setState({
                    error: ''
                });
            }
        }
    }

    render() {
        const { healthrecord, pharmacy, isProgressBar, enableProxyGrantPharmacy} = this.props;
        const { error, showGrantDisclaimerModal } = this.state;
        
        return (
            <div className="grant-access-type-container" style={this.props.style}>               
                    <div className="row">
                        <div className="col-12 text-center">
                            <h1 className={`step-heading step-heading-md` + (isProgressBar ? "" : " no-prog-bar")}>
                                What would you like to grant access to?
                            </h1>
                            {enableProxyGrantPharmacy && <p className="step-description">Select all that apply</p>}
                        </div>
                        <div className="col-12 grant-access">
                            <div className="row justify-content-center row-card-eq">
                                <div className="col-12 col-md-6 text-center">
                                    <label className={`card ${healthrecord ? 'selected' : ''}`} name="healthrecord">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 card-icon">
                                                    <span className={healthrecord ? 'svg-btn-medical-records' : 'svg-btn-medical-records-gray'} />
                                                </div>
                                                <div className="col-12">
                                                    <div className="card-heading">Medical Records</div>
                                                    <div className="card-hint">book appointments, view exam results & message their doctor</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <div className="col-12">
                                                <div className="checkbox-container">
                                                <input type="checkbox" name="healthrecord"  checked={healthrecord} onChange={(e) => this.onAccessTypeChange(e)} />
                                                    <span className="checkmark" />
                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                                <div className="col-12 col-md-6 text-center">
                                    <label className={`card ${pharmacy ? 'selected' : ''} ${enableProxyGrantPharmacy ? '' : 'pharmacy-record-disabled-style no-pointer'}`} name="pharmacy">                                    
                                        {!enableProxyGrantPharmacy && <div className="new-feature">COMING SOON</div>}
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 card-icon">
                                                    <span className={pharmacy ? 'svg-btn-pharmacy' : 'svg-btn-pharmacy-gray'} />
                                                </div>
                                                <div className="col-12">
                                                    <div className="card-heading">Baylor Scott & White Pharmacy</div>
                                                    <div className="card-hint">view & refill prescriptions from a BSW pharmacy</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <div className="col-12">
                                            <div className="checkbox-container">
                                                {enableProxyGrantPharmacy ? <input type="checkbox" name="pharmacy" checked={pharmacy} onChange={(e) => this.onAccessTypeChange(e)} /> :
                                                    <input type="checkbox" disabled name="pharmacy" checked={pharmacy} onChange={(e) => this.onAccessTypeChange(e)} />}
                                                <span className={enableProxyGrantPharmacy ? 'checkmark' : ' checkmark disabled-style'} />
                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>                                                    
                    </div>
                    {(error !== "") && 
                        <div className="col-12 text-center">
                            <div className="error-msg">
                                {error}
                            </div>
                        </div>
                    }
                    {
                        showGrantDisclaimerModal && 
                        <GrantDisclaimerModal
                            isOpen
                            enableCloseButton
                            healthrecord={healthrecord}
                            pharmacy={pharmacy}
                            onAgreeGrantDisclaimer={this.onAgreeGrantDisclaimer} />
                    }
                </div>     

            </div>
        );
    }
}
export default AccessType;